module.exports = __webpack_public_path__ + "static/media/axfood_white.0cccdfee.jpg";